import request from '../../utils/requests'
/** * Tag: OrgUserShortcutEntry */
const baseUrl ="/api/OrgUserShortcutEntry";

/** * 保存快捷入口 * @param {*} body * { *    UserId Desc:用户id Required:false *    DetailList Desc:快捷入口明细列表 Required:false *    OrgId Desc:后台使用 Required:false * } */async function _addOrUpdate(body) {  return request(baseUrl+'/addOrUpdate',{    method: 'POST',    body: body,  });
}

/** * 获取用户的快捷入口分页 * @param {*} body * { *    UserId Desc:用户id Required:false *    OrgId Desc:后台使用 Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _paging(body) {  return request(baseUrl+'/paging',{    method: 'POST',    body: body,  });
}

export default{  _addOrUpdate,  _paging}



// WEBPACK FOOTER //
// ./src/services/orgUserShortcutEntry.js